import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import DateRangeIndicator from '../../../../components/DateRangeIndicator';

export const StyledDateRangeIndicator = styled(DateRangeIndicator)`
  font-size: 15px;
`;

export const NotesWrapper = styled.div`
  margin: 30px 0px;
  max-width: 740px;

  label {
    display: flex;
    margin-bottom: 4px;
  }

  textarea {
    min-height: 155px;
  }

  ${media.xs`
    margin-top: 0;
  `}
`;
